module.exports = __webpack_public_path__ + "img/black-down-arrow.8ff3a330.svg";